import ReactDOM from "react-dom/client"
import React from "react"
import {BrowserRouter} from "react-router-dom"
import App from "./App"

const root = document.getElementById("root")
const app = (
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
)

if (root.hasChildNodes()) {
    ReactDOM.hydrateRoot(root, app)
} else {
    ReactDOM.createRoot(root).render(app)
}
